<svg [climbIcon]="icons.drag"></svg>
